export default __webpack_public_path__ + "static/media/Descargar QR-21.4e98c609.svg";